import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetUser } from "../Redux/Slices/User";
import { needsJobseekerOnboarding } from "../Helper/jobseekerRedirect";

const ALLOWED_PATHS = [
  "/jobseeker/onboarding",
  "/jobseeker/profile",
  "/signin",
  "/signup",
  "/signup-recruiter",
  "/contact",
  "/faq",
  "/about",
  "/reset-account",
];

export default function ProfileCompletionGuard({ children }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const id = localStorage.getItem("id");
  const role = localStorage.getItem("role");
  const { userData, completionPercentage, loading } = useSelector(
    (state) => state?.User
  );

  useEffect(() => {
    if (role === "Jobseeker" && id) {
      dispatch(GetUser(id));
    }
  }, [dispatch, id, role]);

  if (role !== "Jobseeker") {
    return children;
  }

  if (ALLOWED_PATHS.some((p) => location.pathname.startsWith(p))) {
    return children;
  }

  if (loading && !userData) {
    return (
      <div className="jsp-page">
        <div className="jsp-shell" style={{ padding: "3rem 1rem", textAlign: "center" }}>
          Loading your profile...
        </div>
      </div>
    );
  }

  if (needsJobseekerOnboarding(userData, completionPercentage)) {
    return <Navigate to="/jobseeker/onboarding" replace state={{ from: location.pathname }} />;
  }

  return children;
}
